import { MenuItem } from './MenuItem';
import { MenuTitle } from './MenuTitle';
import { MenuGroupProps } from './Menu.types';

export const MenuGroup = ({
  group,
  itemClassName,
  titleClassName,
}: MenuGroupProps) => (
  <>
    <MenuTitle className={titleClassName}>{group.title}</MenuTitle>
    {group.items.map((item) => (
      <MenuItem
        key={item.href}
        href={item.href}
        className={itemClassName}
        isExternal={item.isExternal}
      >
        {item.label}
      </MenuItem>
    ))}
  </>
);
